import {
  CalendarOutline,
  GiftOutline,
  UserOutline,
  ClipboardCloseOutline as ClipboardClose,
  InviteOutline as Invite,
} from '@aslanpay/portal-common-lib';
import { IconProps } from '@chakra-ui/react';

export interface ActionValueType {
  id: string;
  icon?: (props: IconProps) => JSX.Element;
  value: string;
}

export const defaultPageSize = 15;

export enum EmployeeColumns {
  firstName = 'First name',
  lastName = 'Last name',
  email = 'Company email',
  externalPayrollId = 'Payroll ID',
  payCalendarName = 'Payroll',
  status = 'Status',
}

export enum EmployeeActionsIds {
  PROFILE = 'profile',
  EDIT_DETAILS = 'editDetails',
  INVITE = 'invite',
  SET_UNPAID = 'setUnpaid',
  REMOVE_UNPAID = 'removeUnpaid',
  TERMINATE = 'terminate',
  EDIT_TERMINATE = 'editTerminate',
  GIFT = 'gift',
}

export const defaultEmployeeActionsValues: ActionValueType[] = [
  { id: EmployeeActionsIds.PROFILE, icon: UserOutline, value: 'Employee profile' },
  { id: EmployeeActionsIds.INVITE, icon: Invite, value: 'Invite to Aslan' },
  { id: EmployeeActionsIds.SET_UNPAID, icon: ClipboardClose, value: 'Set accrual pause' },
  { id: EmployeeActionsIds.REMOVE_UNPAID, icon: ClipboardClose, value: 'Remove accrual pause' },
  { id: EmployeeActionsIds.TERMINATE, icon: CalendarOutline, value: 'Set leave date' },
  { id: EmployeeActionsIds.EDIT_TERMINATE, icon: CalendarOutline, value: 'Manage leave date' },
  { id: EmployeeActionsIds.GIFT, icon: GiftOutline, value: 'Gift people' },
];

export enum ImportedEmployeeColumns {
  externalPayrollId = 'Payroll ID',
  firstName = 'First name',
  lastName = 'Last name',
  email = 'Company email',
  startDate = 'Start date',
  annualGrossSalary = 'Gross annual salary',
  terminationDate = 'Leave date',
  salaried = 'Salaried employee (Y/N)',
  salaryAppliesDate = 'Salary applies date',
}

export enum AETColumns {
  externalPayrollId = 'Payroll ID',
  approvedEarnings = 'Approved Earnings',
  currency = 'Currency',
  unit = 'Unit',
  rate = 'Rate',
  basis = 'Basis',
  payday = 'Pay day',
}
